import React from 'react';
import { C } from '../../styles/tokens';

/**
 * "Credits used" card — usage progress for the current billing period.
 * Plan name / status / Billing button live in the sibling CurrentPlanCard, and
 * subscription/payment detail lives in BillingModal (opened from that card).
 *
 * Props:
 *   used  – credits used this billing period
 *   total – plan credit cap
 */
export default function UsageThisMonth({ used = 0, total = 0 }) {
  const pct = total > 0 ? Math.round((used / total) * 100) : 0;
  const urgent = pct >= 90;

  return (
    <div style={{ background: C.w, border: `1px solid ${C.n200}`, borderRadius: 13, padding: '16px 18px' }}>
      <div style={{ fontSize: 12.5, color: C.n500, marginBottom: 8 }}>Credits used</div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 10 }}>
        <span style={{ fontSize: 20, fontWeight: 800, color: C.n900 }}>{used.toLocaleString()} credits</span>
        <span style={{ fontSize: 13, color: C.n400 }}>/ {total.toLocaleString()} credits</span>
      </div>
      <div style={{ height: 7, background: C.n100, borderRadius: 4, overflow: 'hidden' }}>
        <div style={{
          width: Math.min(pct, 100) + '%', height: '100%',
          background: urgent ? '#DC2626' : C.n900, borderRadius: 4, transition: 'width .4s',
        }} />
      </div>
    </div>
  );
}
